import React, { FC, ReactElement } from 'react'

import { defineMessages, useIntl } from 'react-intl'

import { LandingTitle } from 'components/page/Landing/LandingView/LandingView.styled'
import { capitalizeFirstLetter } from 'functions/capitalizeFirstLetter'

const messages: Record<string, Record<string, string>> = defineMessages({
  landingTitle: {
    id: 'landing.title.seo.changed',
    defaultMessage: 'Сайт онлайн-знакомств {locationName}',
  },
  landingTitleGirls: {
    id: 'landing.title.seo.girls.changed',
    defaultMessage: 'Сайт онлайн-знакомств c девушками {locationName}',
  },
  landingTitleGuys: {
    id: 'landing.title.seo.guys.changed',
    defaultMessage: 'Сайт онлайн-знакомств c мужчинами {locationName}',
  },
  landingTitleGays: {
    id: 'landing.title.gays.changed',
    defaultMessage: 'Гей-знакомства {locationName}',
  },
  landingTitleLesbians: {
    id: 'landing.title.lesbians.changed',
    defaultMessage: 'Лесби-знакомства {locationName}',
  },
})

export const LandingTitleSwitch: FC<{
  gender: string | undefined
  locationName: string | ReactElement
  title: string | null
}> = ({ gender, locationName, title }) => {
  const intl = useIntl()

  if (title) {
    return (
      <LandingTitle
        data-name="geo-landing-title"
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />
    )
  } else if (locationName) {
    const textId = gender
      ? messages[`landingTitle${capitalizeFirstLetter(gender)}`]
      : messages.landingTitle
    return (
      <LandingTitle data-name="geo-landing-title">
        {intl.formatMessage(textId, { locationName })}
      </LandingTitle>
    )
  }

  return null
}
